// src/hooks/useCategories.js
import { useEffect, useState } from 'react'
import axios from 'axios'

export function useCategories() {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const reload = async () => {
    setLoading(true)
    setError(null)
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/api/category_list/`
      const res = await axios.get(url, { timeout: 5000 })
      setCategories(res.data || [])
    } catch (e) {
      setError(e)
      setCategories([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { reload() }, [])

  return { categories, setCategories, loading, error, reload }
}
